/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { OasisNonClinicalValuesViewModel } from './OasisNonClinicalValuesViewModel'; 

export function getOasisAssessmentNonClinicalValuesOptions(id: string, onSuccess?: (result: OasisNonClinicalValuesViewModel) => void) {
	return queryOptions({
		queryKey: ['oasis-assessment-non-clinical-values', id],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/oasis/queries/getoasisassessmentnonclinicalvalues/' + id;
			const resp = await axios.get<OasisNonClinicalValuesViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(id)
	});
}